<template>
    <div class="section">
        <projects-grid :projects="folder.projects" :showCreationCard="true" />
    </div>
</template>

<script>
import { fetchItem } from '@/services/API';
import ProjectsGrid from '@/components/ProjectsGrid';
export default {
    components: {
        ProjectsGrid,
    },
    props: {},
    data() {
        return {
            folder: {},
        };
    },
    mounted() {
        fetchItem('folder', this.$route.params.folder).then(({ data }) => {
            this.folder = data;
        });
    },
};
</script>

<style></style>
